export const STANDART = "STANDART";
export const ISLAMIC = "ISLAMIC";
export const ELITE = "ELITE";
export const AGENT = "AGENT";
export const NONE = "NONE";
